/**
 * LP treatment options cards (sections/medispa-lp-treatment-options.liquid):
 * clicking a card title expands it and collapses the other cards.
 * Loaded by deferred-scripts.liquid (marker: treatment-card).
 */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const title = event.target.closest('.treatment-card .card-title');
  if (!title) return;

  const card = title.closest('.treatment-card');
  if (!card) return;

  document.querySelectorAll('.treatment-card.active').forEach((activeCard) => {
    if (activeCard !== card) activeCard.classList.remove('active');
  });

  card.classList.toggle('active');
});
